module.exports = __webpack_public_path__ + "community1.928c349f.png";